import React, { memo } from 'react';
import { Subscription } from 'rxjs/Subscription';
import ErrorState from '@atlassian/jira-common-components-error-state';
import ReportErrors from '@atlassian/jira-errors-handling/src/utils/reporting-error-boundary.tsx';
import { useIntl } from '@atlassian/jira-intl';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import PageSpinner from '@atlassian/jira-servicedesk-common/src/ui/components/page-spinner';
import { JsmPageInteractiveEvent } from '@atlassian/jira-servicedesk-common/src/utils/browser-metric/index.tsx';
import { useGroupsResourceStatus } from '../controllers/groups-resource/index.tsx';
import useInit from '../controllers/init/index.tsx';
import useTicketTypesResource from '../controllers/ticket-types-resource/index.tsx';
import StoreContainer from '../services/store';
import { portalGroupsSettingsPageLoad } from '../utils/performance-analytics';
import messages from './messages';
import PageHeader from './page-header';
import { GroupList } from './portal-group';

type Props = {
	projectId: number;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const App = memo<Record<any, any>>(() => {
	const { loading: isGroupsLoading, error: groupsError } = useGroupsResourceStatus();
	const [, , ticketTypesError] = useTicketTypesResource();
	const { formatMessage } = useIntl();
	useInit();

	if (isGroupsLoading) {
		return <PageSpinner />;
	}

	if (groupsError || ticketTypesError) {
		return (
			<ErrorState
				header={formatMessage(messages.errorHeader)}
				description={formatMessage(messages.errorMessage)}
				onRetry={() => {
					// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
					window.location.reload();
				}}
			/>
		);
	}

	return (
		<>
			<PageHeader />
			<GroupList />
			<JsmPageInteractiveEvent
				metricKey="servicedesk.portal-settings.portal-groups"
				// @ts-expect-error - TS2322 - Type 'PageLoadMetric' is not assignable to type 'BM3Metric'.
				metric={portalGroupsSettingsPageLoad}
			/>
		</>
	);
});

const PortalRequestGroups = (props: Props) => (
	<ContextualAnalyticsData
		containerType="project"
		containerId={String(props.projectId)}
		sourceName="jsdPortalRequestGroups"
		sourceType={SCREEN}
	>
		<ReportErrors
			id="portalRequestGroups"
			packageName="jiraServicedeskPortalSettingsRequestGroups"
			teamName="jsd-shield"
		>
			<StoreContainer {...props} activeStreams={new Subscription()}>
				<App />
			</StoreContainer>
			<FireScreenAnalytics />
		</ReportErrors>
	</ContextualAnalyticsData>
);

export default PortalRequestGroups;
